import Head from './Head'
import Menu from './Menu'
import Foot from './Foot'
import Empty from './Empty'

export default {
  install (Vue) {
    Vue.mixin({
      components: {
        'v2-head': Head,
        'v2-menu': Menu,
        'v2-foot': Foot,
        'v2-empty': Empty,
      }
    })
  }
}


// WEBPACK FOOTER //
// ./src/components/saas/v2/index.js